export const notificationManagementText = {
  HEB: {
    title: "ניהול התראות",
    mainToggle: {
      label: "אפשר התראות",
      yes: "כן",
      no: "לא",
    },
    subToggles: {
      monthly_updates: "עדכון חודשי על תמונת המצב הפיננסית שלך בחודש הקודם",
      insights: "התראות על תובנות חדשות עבורך",
      masleka_updates: "עדכוני מסלקה חודשיים כאשר הנכסים הפנסיוניים מתעדכנים",
      announcements: "עדכונים על פיצ׳רים חדשים במאניטור",
      push_enabled: "התראות בדחיפה באפליקציה",
    },
    results: {
      success: {
        header: "הגדרות ההתראות עודכנו בהצלחה",
        details: "השינויים נשמרו במערכת",
        actionButtonText: "סגור",
      },
      error: {
        header: "עדכון הגדרות ההתראות נכשל",
        details: "אירעה שגיאה בעת עדכון ההגדרות",
        actionButtonText: "סגור",
      },
    },
    saveButton: "שמור",
  },
  ENG: {
    title: "Manage notifications",
    mainToggle: {
      label: "Enable notifications",
      yes: "Yes",
      no: "No",
    },
    subToggles: {
      monthly_updates:
        "Monthly update on your financial status for the previous month",
      insights: "Notifications about new insights for you",
      masleka_updates:
        "Monthly Masleka updates when pension assets are updated",
      announcements: "Updates about new Moneytor features",
      push_enabled: "Native push notifications in the app",
    },
    results: {
      success: {
        header: "Notification settings updated successfully",
        details: "Changes saved",
        actionButtonText: "Close",
      },
      error: {
        header: "Failed to update notification settings",
        details: "An error occurred while updating settings",
        actionButtonText: "Close",
      },
    },
    saveButton: "Save",
  },
  RUS: {
    title: "Управление уведомлениями",
    mainToggle: {
      label: "Включить уведомления",
      yes: "Да",
      no: "Нет",
    },
    subToggles: {
      monthly_updates:
        "Ежемесячный отчёт о вашем финансовом состоянии за прошлый месяц",
      insights: "Уведомления о новых инсайтах для вас",
      masleka_updates:
        "Ежемесячные обновления Маслека при обновлении пенсионных активов",
      announcements: "Новости о новых функциях Moneytor",
      push_enabled: "Нативные push-уведомления в приложении",
    },
    results: {
      success: {
        header: "Настройки уведомлений успешно обновлены",
        details: "Изменения сохранены",
        actionButtonText: "Закрыть",
      },
      error: {
        header: "Не удалось обновить настройки уведомлений",
        details: "Произошла ошибка при обновлении настроек",
        actionButtonText: "Закрыть",
      },
    },
    saveButton: "Сохранить",
  },
};
